/**
 * Portrait + background changer locale pack: ko
 */

module.exports = {
  "portrait": {
    "overview": [
      "Miral AI Background Remover는 로그인 후 무료입니다. 어깨 위 인물 사진—LinkedIn, 이력서, WeChat·Instagram 아바타, 증명사진용 투명 마스터—에 잘 맞습니다.",
      "선명한 JPG, PNG 또는 WebP(최대 15 MB)를 업로드하세요. AI가 인물을 자동 감지합니다. 다운로드 전에 잔머리, 안경, 귀걸이, 옷깃 라인을 확대해 확인하세요.",
      "투명 PNG는 완성된 흰/파란 증명사진이 아닙니다. 먼저 투명 마스터를 보관하고, 그다음 필요한 색을 더한 뒤 공식 크기로 자르세요."
    ],
    "practice": [
      "가능하면 카메라 원본으로 시작합니다. 채팅 앱 썸네일과 강한 뷰티 필터는 머리카락 가장자리를 흐리게 하고 안경테를 지키기 어렵게 만듭니다.",
      "컷아웃은 항상 밝은 캔버스와 어두운 캔버스 모두에 올려봅니다. 이 한 번의 확인으로 옅은 헤일로와 빠진 잔머리가 드러납니다."
    ],
    "compareIntro": "이 가이드는 인물용입니다—아바타, 증명사진 스타일, 프로 헤드샷. 상품 흰 배경은 이커머스 가이드, 컷아웃 후 카페·오피스 장면이 필요하면 배경 교체 가이드를 사용하세요.",
    "workflow": "15 MB 이하 선명한 인물 사진을 업로드하고, AI로 전체 배경을 제거한 뒤 머리카락과 안경을 확인하고, 투명 PNG를 다운로드한 다음 흰·파랑·브랜드색을 더합니다.",
    "scenarioIntro": "본인 용도에 가장 가까운 인물 작업을 고른 뒤, 그 용도에서 자주 실패하는 가장자리를 집중 확인하세요.",
    "sec": {
      "tldrTitle": "짧은 요약",
      "tldrCols": [
        "필요한 것",
        "세부 사항"
      ],
      "tldrRows": [
        [
          "가격",
          "Miral AI Background Remover는 로그인 후 무료"
        ],
        [
          "업로드",
          "JPG, PNG 또는 WebP(최대 15 MB)"
        ],
        [
          "적합한 용도",
          "LinkedIn 헤드샷, 이력서 사진, 아바타, 증명사진 마스터"
        ],
        [
          "다운로드",
          "투명 PNG. 흰/파란 배경은 나중에 추가"
        ],
        [
          "꼼꼼히 볼 곳",
          "머리카락, 안경, 귀걸이, 옷깃, 어깨"
        ],
        [
          "이 글이 아닌 것",
          "마켓플레이스 상품 흰 배경은 이커머스 가이드로"
        ]
      ],
      "tldrP": "거리 셀피나 급한 사무실 스냅도 Miral AI에서 깔끔한 헤드샷이 될 수 있습니다. 한 번 잘라내고 투명 파일을 보관한 뒤, 실제로 필요한 흰·파랑·브랜드색 버전을 만드세요.",
      "whatTitle": "아바타, 증명사진, LinkedIn 헤드샷이 각각 필요한 것",
      "whatP1": "세 용도 모두 첫 단계는 같습니다. Miral AI Background Remover로 인물을 잘라내고 깨끗한 투명 PNG를 보관하세요. 차이는 나중에 더하는 색과 크롭입니다.",
      "whatAvatarP": "아바타 배경 제거가 해결하는 것: 침실 셀피와 거리 스냅은 얼굴을 어수선한 배경에 묻습니다. 배경을 지우고 브랜드색이나 단색에 올린 뒤 Instagram·WeChat·개인 사이트용 원형 크롭을 미리보세요.",
      "galleryAvatarCaption": "아바타 예: 왼쪽은 어수선한 실내 셀피, 오른쪽은 원형 프로필용 단색에 올린 컷아웃.",
      "whatIdP": "증명사진 배경 제거가 해결하는 것: 신청서는 종종 흰 또는 파랑을 요구합니다. 거실 스냅은 보통 그 규칙을 통과하지 못합니다. 한 번 잘라내고 필요한 색을 더한 뒤 공식 크기로 자릅니다. 제출 전 최신 양식 규칙을 다시 확인하세요.",
      "galleryIdCaption": "증명사진 예: 왼쪽은 복잡한 집 배경, 오른쪽은 크기 크롭용 순백 배경의 같은 인물.",
      "whatLinkedInP": "LinkedIn 헤드샷 컷아웃이 해결하는 것: 오픈 오피스는 모니터와 동료를 뒤에 둡니다. 차분한 회색이나 흰 배경은 채용 담당자가 먼저 보는 얼굴과 옷으로 시선을 돌립니다.",
      "galleryLinkedInCaption": "LinkedIn 예: 왼쪽은 바쁜 사무실 셀피, 오른쪽은 채용용 소프트 그레이에 올린 컷아웃.",
      "whatTipTitle": "세 용도 모두 하나의 투명 마스터",
      "whatTipText": "먼저 투명 PNG를 다운로드하세요. 브랜드색 아바타, 흰/파란 증명사진 내보내기, 소프트 그레이 LinkedIn 카드는 모두 같은 파일에서 파생합니다.",
      "howTitle": "쓸 수 있는 헤드샷까지 네 단계",
      "howP": "Miral AI Background Remover를 열고 어깨 위 사진을 업로드한 뒤 자동 감지를 기다리고, 다운로드 전 머리카락과 안경을 100%로 확대 확인하세요. 가장자리가 깨끗해진 뒤에만 흰/파랑을 더합니다.",
      "howTipTitle": "원본 파일 우선",
      "howTipText": "강한 뷰티 필터와 메신저 압축은 잔머리를 흐리게 합니다. 카메라 원본이 거의 항상 이깁니다.",
      "edgeTitle": "인물에서 자주 실패하는 곳",
      "edgeCols": [
        "부위",
        "흔한 실수",
        "확인 방법"
      ],
      "edgeRows": [
        [
          "잔머리",
          "배경으로 지워짐",
          "어두운 캔버스와 밝은 캔버스 모두에서 확인"
        ],
        [
          "안경",
          "템플 누락 또는 렌즈 구멍",
          "프레임 모서리를 확대"
        ],
        [
          "귀걸이 / 가는 체인",
          "금속선이 끊김",
          "주얼리 가장자리를 따라감"
        ],
        [
          "옷깃과 블레이저 라인",
          "흰 헤일로 또는 들쭉날쭉한 어깨",
          "어두운 캔버스에 올림"
        ],
        [
          "수염이나 구레나룻",
          "잔수염이 뭉개짐",
          "원본 리터치를 줄이고 재시도"
        ]
      ],
      "edgeP": "썸네일에서 “괜찮아 보임”으로는 부족합니다. 두 배경색에서 실물 크기로 보는 것이 가장 빠른 정직 테스트입니다.",
      "useTitle": "아바타, LinkedIn, 이력서, 증명사진 스타일",
      "useCols": [
        "용도",
        "전형적인 배경",
        "실무 메모"
      ],
      "useRows": [
        [
          "LinkedIn / 채용 사이트",
          "소프트 그레이, 흰, 또는 깨끗한 블러",
          "얼굴은 선명하게. 조용한 배경이 이김"
        ],
        [
          "WeChat / Instagram 아바타",
          "브랜드색 또는 단순 그라데이션",
          "게시 전 원형 크롭 미리보기"
        ],
        [
          "이력서 첨부",
          "흰 또는 연한 회색",
          "머리 위와 어깨 아래 여백 남기기"
        ],
        [
          "일반 증명사진 스타일 출력",
          "흰 또는 파랑",
          "투명 PNG에 필요 색을 더한 뒤 크롭"
        ],
        [
          "여권 / 비자 사진",
          "현행 공식 규칙 준수",
          "색·표정·안경 규칙은 국가마다 다름"
        ],
        [
          "강의·라이브 커버",
          "브랜드색 또는 이후 장면",
          "먼저 깨끗이 잘라낸 뒤 커버 디자인"
        ]
      ],
      "useTipTitle": "규칙은 바뀝니다",
      "useTipText": "비자·시험 사진 규정은 국가와 연도에 따라 다릅니다. 도구는 피사체를 정리하지만, 규정 준수는 공식 체크리스트에서 옵니다.",
      "hairTitle": "머리카락 컷아웃과 안경",
      "hairItems": [
        "역광 잔머리는 더 단순하고 대비가 높은 원본이 필요합니다.",
        "안경이 있으면 양쪽 템플과 렌즈 영역이 남아 있는지 확인하세요.",
        "어두운 벽 앞 검은 머리는 출발점으로 불리합니다—가능하면 밝은 벽 근처로.",
        "흰 벽 앞 밝은 스웨터는 어깨 가장자리를 잃기 쉬우니 촬영 배경을 바꾸세요.",
        "긴 컬과 아이 잔머리는 다운로드 전 반드시 100% 확대 확인이 필요합니다."
      ],
      "hairP": "큰 옷 형태가 인물 컷아웃을 망치는 경우는 드뭅니다. 머리카락과 안경이 망칩니다. 그곳에 추가 1분을 씁니다.",
      "troubleTitle": "헤드샷이 이상할 때",
      "troubleCols": [
        "문제",
        "가능 원인",
        "시도할 것"
      ],
      "troubleRows": [
        [
          "머리카락 덩어리가 빠짐",
          "부드럽거나 압축·역광 원본",
          "뷰티를 줄인 더 선명한 원본 사용"
        ],
        [
          "얼굴·어깨의 옅은 테두리",
          "옛 배경색이 가장자리에 남음",
          "어두운 캔버스에서 확인 후 대비를 높여 재시도"
        ],
        [
          "안경테가 끊김",
          "강한 반사가 외곽선을 혼란",
          "렌즈에 더 부드러운 빛으로 재촬영"
        ],
        [
          "옷이 벽에 녹아듦",
          "피사체/배경 대비 부족",
          "같은 파일 재전송 대신 배경 변경"
        ],
        [
          "증명사진이 노랗게 보임",
          "원본 화이트밸런스가 따뜻함",
          "먼저 잘라낸 뒤 최종 캔버스에서 색 중화"
        ]
      ],
      "troubleTipTitle": "입력을 바꾸세요",
      "troubleTipText": "같은 부드러운 셀피를 다시 올려도 머리카락은 거의 고치지 못합니다. 더 깨끗한 원본이 보통 해결합니다.",
      "prosConsTitle": "도움이 되는 점—그리고 스스로 결정할 점",
      "bestTitle": "아바타를 쓸 수 있게 만드는 습관",
      "bestItems": [
        "머리 위 약간의 여백이 있는 어깨 위 구도를 사용하세요.",
        "표정은 자연스럽게. 컷아웃 전 강한 피부 보정은 피하세요.",
        "매번 밝은·어두운 캔버스에서 PNG를 확인하세요.",
        "투명 마스터, 색 증명사진 내보내기, 최종 크롭을 별도 파일로 저장하세요.",
        "채용 플랫폼에서는 조용한 배경이 얼굴과 옷을 더 잘 읽히게 합니다.",
        "다음에 카페·오피스 분위기가 필요하면 먼저 깨끗이 잘라낸 뒤 배경 교체 가이드로."
      ],
      "miralTitle": "컷아웃 다음에 할 일",
      "miralP": "Miral AI에서 인물을 선명하게 하거나, 조용한 아바타 카드를 만들거나, Seedream·FLUX.2로 커버 장면을 이어갈 수 있습니다. 라이프스타일 배경 교체는 AI 배경 교체 가이드로. 상품 리스팅 흰 배경은 이커머스 가이드를 사용하세요.",
      "miralLinksTitle": "다음 단계",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "AI 배경 교체 가이드",
          "path": "/hub/articles/ai-background-changer-online"
        },
        {
          "label": "일반 AI 배경 제거 가이드",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "이커머스 상품 배경 가이드",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        }
      ],
      "intentsTitle": "흔한 인물 워크플로",
      "faqTitle": "업로드 전 자주 묻는 질문",
      "faqItems": [
        [
          "온라인에서 인물 배경을 무료로 지우려면?",
          "Miral AI에 로그인한 뒤 어깨 위 JPG·PNG·WebP를 업로드하고 투명 PNG를 다운로드하세요."
        ],
        [
          "셀피로 흰/파란 증명사진을 만들려면?",
          "먼저 투명 PNG를 내보내고 필요한 흰/파랑을 더한 뒤 공식 크기로 자르고 제출 전 최신 규정을 재확인하세요."
        ],
        [
          "배경 제거로 LinkedIn 헤드샷을 만들려면?",
          "복잡한 사무실 배경을 지우고 소프트 그레이 또는 흰 배경에 올린 뒤, 업로드 전 머리카락과 어깨 가장자리를 확인하세요."
        ],
        [
          "WeChat·Instagram 아바타 배경을 무료로 지울 수 있나요?",
          "네. 로그인 후 아바타 원본을 처리하고 브랜드색 위에서 원형 크롭을 미리보세요."
        ],
        [
          "안경 쓴 사진을 온라인에서 잘라낼 수 있나요?",
          "네. 다만 다운로드 전에 프레임, 템플, 렌즈 영역을 확대 확인하세요."
        ],
        [
          "인물 머리카락 컷아웃에 쓸 도구는?",
          "카메라 원본으로 Miral AI Background Remover를 쓰고 밝은·어두운 캔버스에서 잔머리를 확인하세요."
        ],
        [
          "여권 사진 배경 준비에 쓸 도구는?",
          "먼저 투명 인물 마스터를 만든 뒤 공식 배경색과 밀리미터 크기로 내보내세요."
        ],
        [
          "인물 배경 제거 후 흰 헤일로를 고치려면?",
          "투명 PNG를 어두운 캔버스에 올려 테두리를 찾고, 더 선명하고 대비 높은 원본으로 재시도하세요."
        ],
        [
          "컬·아이 사진에서 빠진 잔머리를 고치려면?",
          "강한 뷰티와 채팅 썸네일을 피하고 더 선명한 원본을 쓴 뒤 다운로드 전 100%로 확인하세요."
        ],
        [
          "프로 헤드샷을 한 번에 여러 장 처리할 수 있나요?",
          "현재 페이지는 머리카락 가장자리를 확인할 수 있도록 한 장씩 처리합니다."
        ],
        [
          "투명과 흰 증명사진 배경의 차이는?",
          "투명 PNG는 나중에 어떤 색이든 받을 수 있습니다. 흰 증명사진 내보내기는 양식·이력서용 흰 픽셀을 이미 포함합니다."
        ],
        [
          "이후에 카페·오피스 장면으로 배경을 바꾸려면?",
          "투명 PNG가 검수를 통과한 뒤 AI 배경 교체 가이드를 따르고 조명 일치를 확인하세요."
        ]
      ]
    },
    "linksTitle": "Miral AI에서 계속하기",
    "linksIntro": "투명 인물 마스터를 보관한 뒤 향상하거나, 아바타 카드를 만들거나, 라이프스타일 장면으로 이동하세요.",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "AI 배경 교체 가이드",
        "path": "/hub/articles/ai-background-changer-online"
      },
      {
        "label": "일반 AI 배경 제거 가이드",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "이커머스 상품 배경 가이드",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "선명한 어깨 위 사진 선택",
        "text": "얼굴과 어깨가 완전히 보이는 JPG·PNG·WebP(최대 15 MB)를 사용하세요."
      },
      {
        "title": "배경 자동 제거",
        "text": "Miral AI Background Remover가 인물을 감지하고 전체 배경을 지웁니다—수동 외곽선 불필요."
      },
      {
        "title": "머리카락과 안경 확인",
        "text": "잔머리, 프레임, 귀걸이, 옷깃 라인을 확대하세요."
      },
      {
        "title": "투명 PNG 다운로드 후 색 추가",
        "text": "마스터를 보관하고 최종 용도에 흰·파랑·회색·브랜드색을 더하세요."
      }
    ],
    "pros": [
      "아바타·증명사진 스타일에 쓰는 인물 가장자리용",
      "머리카락에 Photoshop 펜 툴 불필요",
      "투명 PNG 하나로 여러 배경색 가능",
      "로그인 후 브라우저 내 무료 처리"
    ],
    "cons": [
      "가는 머리카락은 실물 크기 확인 필요",
      "역광·저대비는 가장자리를 부드럽게 만들 수 있음",
      "현재 페이지는 한 장씩",
      "공식 증명사진 규정은 수동 준수 확인 필요"
    ],
    "tips": [
      {
        "title": "캔버스 색 두 가지 확인",
        "text": "밝은·어두운 배경이 헤일로와 빠진 가닥을 빨리 드러냅니다."
      },
      {
        "title": "안경과 주얼리 보호",
        "text": "다운로드 전 템플, 렌즈 모서리, 가는 체인을 확대하세요."
      },
      {
        "title": "마스터와 증명사진 내보내기 분리",
        "text": "투명 PNG를 납작한 흰/파란 파일로 덮어쓰지 마세요."
      },
      {
        "title": "필터는 가볍게",
        "text": "강한 뷰티는 모델이 필요한 정확한 가장자리를 흐리게 합니다."
      },
      {
        "title": "다음에 열 가이드 알기",
        "text": "장면 교체 → 배경 체인저. 상품 흰 배경 → 이커머스 가이드."
      }
    ],
    "scenarios": [
      {
        "title": "LinkedIn 헤드샷 배경 제거",
        "text": "선명한 어깨 위 사진을 잘라낸 뒤 업로드 전 소프트 그레이 또는 흰 배경에 올리세요."
      },
      {
        "title": "WeChat·Instagram 아바타 컷아웃",
        "text": "투명 PNG를 다운로드하고 브랜드색에서 원형 크롭을 미리보세요."
      },
      {
        "title": "이력서 사진 흰 배경",
        "text": "투명 마스터를 보관하고 PDF용 흰 배경 파일을 따로 내보내세요."
      },
      {
        "title": "파란 배경 증명사진 스타일",
        "text": "머리카락 가장자리가 깨끗해진 뒤에만 필요한 파랑을 더하세요."
      },
      {
        "title": "온라인에서 머리카락 주변 배경 제거",
        "text": "카메라 원본을 쓰고 밝은·어두운 캔버스에서 잔머리를 확인하세요."
      },
      {
        "title": "안경 인물 컷아웃",
        "text": "다운로드를 믿기 전에 프레임 모서리와 템플을 확대하세요."
      },
      {
        "title": "여권 사진 준비",
        "text": "먼저 투명 PNG를 만든 뒤 해당 국가의 현행 크기·색 규칙을 따르세요."
      },
      {
        "title": "사무실 셀피에서 프로 헤드샷으로",
        "text": "복도 잡동사니를 지우고 자연 표정을 유지하며 강한 필터를 피하세요."
      },
      {
        "title": "아이·컬 머리 컷아웃",
        "text": "잔머리가 더 많습니다. 항상 100%로 확인하세요."
      },
      {
        "title": "투명 vs 흰 인물 배경",
        "text": "투명은 재사용 가능. 흰은 특정 양식용 납작한 내보내기입니다."
      },
      {
        "title": "얼굴 컷아웃의 흰 헤일로 수정",
        "text": "어두운 캔버스에서 테두리를 확인하고 원본 대비를 높여 재시도하세요."
      },
      {
        "title": "인물 컷아웃에서 카페 장면으로",
        "text": "투명 PNG가 검수를 통과한 뒤 배경 교체 가이드를 사용하세요."
      }
    ],
    "toolFaq": [
      {
        "q": "온라인에서 인물 배경을 무료로 지우려면?",
        "a": "로그인 후 인물을 업로드하고 데스크톱 소프트웨어 없이 투명 PNG를 다운로드하세요."
      },
      {
        "q": "셀피로 흰/파란 증명사진을 만들려면?",
        "a": "배경을 지우고 투명 PNG를 보관한 뒤 필요 색을 더하고 공식 크기로 자르세요."
      },
      {
        "q": "WeChat·Instagram 아바타 배경을 무료로 지울 수 있나요?",
        "a": "네. 로그인 후 아바타 원본을 처리하고 브랜드색에서 원형 크롭을 미리보세요."
      },
      {
        "q": "안경 쓴 사진을 온라인에서 잘라낼 수 있나요?",
        "a": "네. 다운로드 전 템플과 렌즈 영역을 실물 크기로 확인하세요."
      },
      {
        "q": "인물 머리카락 컷아웃에 쓸 도구는?",
        "a": "선명한 원본으로 Miral AI Background Remover를 쓰고 밝은·어두운 캔버스에서 잔머리를 확인하세요."
      },
      {
        "q": "여권 사진 배경 준비에 쓸 도구는?",
        "a": "먼저 투명 인물 마스터를 만든 뒤 양식이 요구하는 공식 색과 크기로 내보내세요."
      },
      {
        "q": "인물 배경 제거 후 흰 헤일로를 고치려면?",
        "a": "어두운 캔버스에서 테두리를 확인하고 더 선명하고 대비 높은 원본으로 재시도하세요."
      },
      {
        "q": "컬·아이 사진에서 빠진 잔머리를 고치려면?",
        "a": "강한 뷰티와 채팅 썸네일을 피하고 더 선명한 원본으로 100% 확인하세요."
      },
      {
        "q": "프로 헤드샷을 한 번에 여러 장 처리할 수 있나요?",
        "a": "현재 페이지는 한 장씩 처리합니다."
      },
      {
        "q": "이후에 카페 장면으로 배경을 바꾸려면?",
        "a": "검수된 투명 PNG를 AI 배경 교체 워크플로와 함께 사용하세요."
      }
    ]
  },
  "changer": {
    "overview": [
      "배경 변경은 두 단계가 가장 잘 됩니다. 무료 배경 제거로 투명 PNG를 만든 뒤, 새 장면—카페 빛, 조용한 오피스, 브랜드 벽, 야외 주광—에 배치합니다.",
      "컷아웃은 Miral AI Background Remover가 담당합니다. 이후 Seedream이나 FLUX.2로 라이프스타일 장면을 만들 수 있습니다. Amazon식 순백 상품 플레이트와 혼동하지 마세요. 그 흐름은 이커머스 가이드에 있습니다.",
      "컷아웃에 옅은 테두리가 남아 있으면 어떤 새 장면도 가짜로 보입니다. 먼저 가장자리를 고치고, 그다음 분위기를 생각합니다."
    ],
    "practice": [
      "투명 피사체가 밝은 캔버스와 어두운 캔버스 모두에서 깨끗해 보일 때까지 합성하지 않습니다.",
      "“예쁨”보다 빛 방향을 먼저 맞춥니다. 창광 인물을 네온 밤거리에 올리면 거의 속이지 못합니다."
    ],
    "compareIntro": "투명 마스터는 배경 제거, 라이프스타일·커버 장면은 이 가이드, 증명사진 스타일 색은 인물 가이드, 마켓플레이스 흰 배경은 이커머스 가이드를 사용하세요.",
    "workflow": "피사체를 잘라내고, 조명에 맞는 장면을 고르고, 새 환경을 합성하거나 생성한 뒤, 내보내기 전 접촉 그림자·색온도·가장자리를 확인합니다.",
    "scenarioIntro": "먼저 장면 목표를 정하고, 완성 크롭과 별도로 투명 마스터를 보관하세요.",
    "sec": {
      "tldrTitle": "실제로 통하는 순서",
      "tldrCols": [
        "단계",
        "보관할 것",
        "주의"
      ],
      "tldrRows": [
        [
          "1. 배경 제거",
          "Miral AI 투명 PNG 마스터",
          "옛 헤일로가 이후 장면을 모두 망침"
        ],
        [
          "2. 장면 선택",
          "카페, 오피스, 브랜드 벽, 야외",
          "무작위 미학이 아니라 용도로 선택"
        ],
        [
          "3. 합성 또는 생성",
          "라이프스타일 또는 커버 이미지",
          "빛 방향과 색온도 맞추기"
        ],
        [
          "4. 검토",
          "게시 가능한 내보내기",
          "가장자리, 스케일, 접촉감"
        ],
        [
          "흰 플레이트와 분리",
          "흰 SKU는 이커머스 가이드",
          "이 글은 장면 교체용"
        ]
      ],
      "tldrP": "배경 변경은 마법 필터 한 번이 아닙니다. Miral AI에서는 Background Remover로 피사체를 분리한 뒤 새 자리를 줍니다. 첫 작업을 건너뛰면 두 번째는 거의 항상 붙여넣기처럼 보입니다.",
      "removeTitle": "라이프스타일, 소셜 커버, 이벤트 포스터는 각각 다른 플레이트가 필요",
      "removeP1": "옛 벽 색은 머리카락과 재킷 가장자리에 붙습니다. 안정적인 길은 같습니다. Miral AI Background Remover → 투명 PNG 마스터 → 용도에 맞는 새 장면. 마켓플레이스 흰 상품 플레이트는 이커머스 가이드로.",
      "removeLifestyleP": "라이프스타일 배경 변경이 해결하는 것: 카페 빛, 창가, 집 코너는 분위기를 만들지만 지저분한 원본 배경은 프레임 전체를 싸구려로 보이게 합니다. 깨끗이 잘라낸 뒤 얼굴 빛과 맞는 장면에 인물을 두세요.",
      "galleryLifestyleCaption": "라이프스타일 예: 왼쪽은 투명 마스터, 오른쪽은 밝은 카페 장면에 합성한 같은 인물.",
      "removeSocialP": "소셜 커버 배경 변경이 해결하는 것: Instagram, Xiaohongshu, LinkedIn 헤더는 선명한 얼굴과 제목 공간이 필요합니다. 어수선한 침실이나 오픈 오피스는 프레임을 채웁니다. 브랜드 그라데이션이나 조용한 색 벽은 인물을 한쪽에 두고 다른 쪽에 카피 공간을 남깁니다.",
      "gallerySocialCaption": "소셜 커버 예: 왼쪽은 투명 마스터, 오른쪽은 헤드라인 공간이 있는 브랜드 그라데이션 벽.",
      "removePosterP": "이벤트 포스터 배경 변경이 해결하는 것: 웨비나, 강의 론칭, 토크 공지는 책상 셀피가 아니라 차분한 무대나 브랜드 벽이 필요합니다. 컷아웃 후 제목 여백이 있는 부드러운 브랜드 플레이트에 인물을 두고, 필요하면 GPT Image로 글자를 더하세요.",
      "galleryPosterCaption": "이벤트 포스터 예: 왼쪽은 투명 마스터, 오른쪽은 토크·강의 커버용 부드러운 브랜드 벽.",
      "removeTipTitle": "마스터, 장면, 커버 크롭을 분리",
      "removeTipText": "투명 PNG를 카페나 그라데이션 내보내기 하나로 덮어쓰지 마세요. 다음 시즌 포스터는 같은 컷아웃을 재사용해야 합니다.",
      "howTitle": "실무 온라인 워크플로",
      "howP": "먼저 Miral AI Background Remover로 신뢰할 수 있는 투명 피사체를 만드세요. 그다음 배경 유형을 고릅니다. 단색이 가장 빠르고, 실사 플레이트가 다음, AI 생성 환경이 가장 유연합니다. 내보내기 전 인물이 배경과 같은 세상의 빛을 받는지 확인하세요.",
      "howTipTitle": "장식보다 빛",
      "howTipText": "얼굴과 싸우는 극적인 장면보다 빛이 맞는 조용한 배경이 이깁니다.",
      "sceneTitle": "클릭되기 쉬운 장면 아이디어",
      "sceneCols": [
        "방향",
        "적합한 용도",
        "주의"
      ],
      "sceneRows": [
        [
          "밝은 카페 / 창가",
          "개인 브랜드와 라이프스타일 커버",
          "따뜻한 전구가 피부를 너무 오렌지빛으로 밀 수 있음"
        ],
        [
          "조용한 오피스 / 책장 소프트 블러",
          "LinkedIn과 강의 멘토 이미지",
          "배경 소품은 얼굴보다 조용해야 함"
        ],
        [
          "야외 주광과 녹음",
          "여행, 웰니스, 라이프스타일 게시물",
          "원본과 싸우는 정오 강한 탑라이트 피하기"
        ],
        [
          "단색 또는 소프트 브랜드 그라데이션 벽",
          "이벤트 포스터와 소셜 헤더",
          "오버레이 텍스트용 대비 유지"
        ],
        [
          "무대·키노트 조명",
          "토크 공지",
          "플레어가 얼굴을 가로지르지 않게"
        ],
        [
          "홈 라이프스타일 코너",
          "부드러운 상품 스토리텔링",
          "원근과 인물 스케일 일관 유지"
        ]
      ],
      "sceneP": "클릭되기 쉬운 것은 대개 명확하고 복잡하지 않은 것입니다. 의도된 조용한 배경에 깨끗한 인물이 있는 편이 바쁜 콜라주보다 강한 경우가 많습니다.",
      "qualityTitle": "가짜가 드러나는 다섯 곳",
      "qualityItems": [
        "머리카락과 어깨: 옛 방의 흰·색 프린지 잔여.",
        "빛 방향: 얼굴 하이라이트와 창광이 일치해야 함.",
        "색온도: 따뜻한 실내 피부를 차가운 파란 플레이트에 올리면 갈라져 보임.",
        "스케일: 인물이 스티커처럼 떠 있거나 잘못된 깊이로 줄어들면 안 됨.",
        "접촉: 바닥이나 의자 접촉의 힌트가 있으면 합성이  설득력 있어집니다."
      ],
      "qualityTipTitle": "일찍 크롭 미리보기",
      "qualityTipText": "최종 장면을 확정하기 전에 정사각 아바타와 와이드 커버 크롭을 확인하세요.",
      "vsTitle": "다른 가이드와의 구분",
      "vsCols": [
        "가이드",
        "주요 작업",
        "열 때"
      ],
      "vsRows": [
        [
          "일반 AI 배경 제거",
          "임의 피사체 → 투명 PNG",
          "컷아웃만 필요할 때"
        ],
        [
          "이커머스 상품 배경",
          "흰/투명 상품 플레이트",
          "Amazon·Shopify 리스팅 준수"
        ],
        [
          "인물 배경 제거",
          "아바타와 증명사진 스타일 색",
          "얼굴, 머리카락, 흰/파란 증명 마스터"
        ],
        [
          "AI 배경 교체(이 글)",
          "컷아웃 후 장면 교체",
          "카페, 오피스, 브랜드 벽 분위기"
        ]
      ],
      "vsP": "네 가이드를 교차 링크하되 키워드는 정직하게 유지하세요. 흰 상품 플레이트는 라이프스타일 글에, 비자 파란 증명사진은 카페 합성 피치에 넣지 마세요.",
      "troubleTitle": "새 장면이 이상할 때",
      "troubleCols": [
        "문제",
        "원인",
        "고치는 법"
      ],
      "troubleRows": [
        [
          "피사체 주변 밝은 프린지",
          "컷아웃이 아직 더러움",
          "대비 높은 원본으로 제거로 복귀"
        ],
        [
          "스티커처럼 보임",
          "접촉 부족 또는 빛 불일치",
          "플레이트를 부드럽게 하거나 아주 옅은 접촉 그림자 추가"
        ],
        [
          "피부가 회색·오렌지빛",
          "색온도 충돌",
          "더 가까운 온도 장면을 고르거나 그레이드를 통일"
        ],
        [
          "머리카락이 지저분해 보임",
          "가닥 주변 알파 불완전",
          "재합성 전 컷아웃을 정리"
        ],
        [
          "AI 장면에서 상품 형태가 어긋남",
          "생성이 객체를 바꿈",
          "정체성을 고정하고 AI에는 환경만 만들게"
        ]
      ],
      "prosConsTitle": "이 워크플로가 열어 주는 것",
      "bestTitle": "휴대폰 화면에서도 버티는 교체",
      "bestItems": [
        "깨끗한 투명 마스터를 절대 건너뛰지 마세요.",
        "채널이 장면을 결정합니다: 채용은 조용, 라이프스타일은 숨 쉴 공간, 포스터는 제목 공간.",
        "단순한 원본 조명이 교체를 쉽게 만듭니다.",
        "게시 전 휴대폰 크기로 항상 미리보세요.",
        "장면이 된 뒤에 헤드라인 텍스트를 더하세요—GPT Image가 포스터 글자에 도움이 됩니다.",
        "마켓플레이스 흰 SKU는 이커머스 가이드로 보내 의도를 분리하세요."
      ],
      "miralTitle": "체인을 Miral AI 안에 유지",
      "miralP": "Miral AI 권장 경로: Background Remover → 선택적 Image Enhancer → 환경에 Seedream 또는 FLUX.2 → 포스터 글자가 필요하면 GPT Image. 증명사진 스타일 흰/파란 카드는 인물 가이드로 돌아가세요.",
      "miralLinksTitle": "다음 단계",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "인물·증명사진 가이드",
          "path": "/hub/articles/ai-portrait-background-remover"
        },
        {
          "label": "일반 AI 배경 제거 가이드",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "이커머스 상품 배경 가이드",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        },
        {
          "label": "GPT Image 1.5",
          "path": "/image-models/gpt-image-ai-image-generator"
        }
      ],
      "intentsTitle": "흔한 배경 변경 작업",
      "faqTitle": "실무 질문",
      "faqItems": [
        [
          "온라인에서 사진 배경을 무료로 바꾸려면?",
          "Miral AI에 로그인한 뒤 Background Remover로 투명 PNG를 내보내고 카페, 브랜드 벽 또는 새 장면에 피사체를 두세요."
        ],
        [
          "투명 PNG로 라이프스타일 이미지를 만들려면?",
          "빛이 맞는 플레이트에 합성하고 접촉·색온도를 확인한 뒤 마스터와 커버 크롭을 분리하세요."
        ],
        [
          "컷아웃 후 소셜 커버 배경을 바꾸려면?",
          "머리카락 가장자리가 검수를 통과한 뒤 브랜드 그라데이션 한쪽에 피사체를 두고 제목 공간을 남기세요."
        ],
        [
          "셀피 배경을 카페 장면으로 바꿀 수 있나요?",
          "네. 먼저 깨끗이 잘라낸 뒤 창광이 얼굴과 맞는 카페 플레이트에 합성하세요."
        ],
        [
          "실물 인물 뒤에 새 AI 장면을 생성할 수 있나요?",
          "네. 투명 PNG의 실물 피사체를 남기고 Seedream 또는 FLUX.2에는 환경만 만들게 하세요."
        ],
        [
          "이벤트 포스터 배경 교체에 쓸 도구는?",
          "컷아웃은 Miral AI Background Remover, 부드러운 브랜드 벽에 배치하고 필요하면 GPT Image로 헤드라인 글자를 더하세요."
        ],
        [
          "소셜 커버 배경 교체에 쓸 도구는?",
          "Background Remover와 브랜드색·그라데이션 벽. 더 풍부한 라이프스타일 장면이 필요하면 Seedream 또는 FLUX.2로."
        ],
        [
          "가짜처럼 보이는 배경 합성을 고치려면?",
          "프린지, 빛 방향, 색온도 순으로 확인하세요. 가장자리가 더러우면 먼저 배경 제거로 돌아가세요."
        ],
        [
          "배경 변경 시 야외 주광 불일치를 고치려면?",
          "태양 방향을 맞추고, 실내용으로 찍힌 얼굴에 정오 강한 탑라이트를 피하세요."
        ],
        [
          "동영상 커버에 배경 변경을 쓸 수 있나요?",
          "네. 커버 비율 크롭을 내보내고 세이프 에어리어 안에 피사체를 두세요."
        ],
        [
          "배경 제거와 배경 변경의 차이는?",
          "제거는 투명 피사체를 만듭니다. 변경은 그 피사체를 새 장면이나 색에 둡니다."
        ],
        [
          "Amazon 흰 상품 배경에 쓸 수 있나요?",
          "아니요. 마켓플레이스 흰 플레이트는 이커머스 가이드로. 이 글은 라이프스타일·커버 장면용입니다."
        ]
      ]
    },
    "linksTitle": "Miral AI에서 장면 워크플로 구성",
    "linksIntro": "한 번 잘라내고 투명 마스터를 보관한 뒤, 마스크를 다시 만들지 않고 라이프스타일 장면·커버·포스터 플레이트를 만드세요.",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "인물·증명사진 가이드",
        "path": "/hub/articles/ai-portrait-background-remover"
      },
      {
        "label": "일반 AI 배경 제거 가이드",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "이커머스 상품 배경 가이드",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      },
      {
        "label": "GPT Image 1.5",
        "path": "/image-models/gpt-image-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "먼저 깨끗한 피사체를 잘라내기",
        "text": "Miral AI Background Remover로 투명 PNG를 다운로드하고 머리카락·상품 가장자리를 확인하세요."
      },
      {
        "title": "새 장면의 분위기 결정",
        "text": "카페, 조용한 오피스, 야외 주광, 브랜드 벽—채널에 맞게 고르세요."
      },
      {
        "title": "새 배경에 피사체 배치",
        "text": "디자인 캔버스에서 합성하거나 빛을 맞춰 Seedream / FLUX.2로 이어가세요."
      },
      {
        "title": "빛, 스케일, 접촉 확인",
        "text": "프린지, 색 충돌, 잘못된 크기, 접촉감 부족을 보세요."
      },
      {
        "title": "필요한 크롭 내보내기",
        "text": "커버와 아바타 크기를 따로 저장하고 투명 마스터는 그대로 두세요."
      }
    ],
    "pros": [
      "투명 마스터 하나로 여러 장면 지원",
      "매번 재촬영보다 저렴",
      "소셜 커버와 라이프스타일 프레임에 강함",
      "Seedream·FLUX.2 장면 작업과 자연스럽게 연결"
    ],
    "cons": [
      "빛 불일치는 즉시 가짜로 읽힘",
      "더러운 컷아웃 가장자리가 합성 전체를 망침",
      "마켓플레이스 흰 SKU는 이커머스 가이드를 써야 함",
      "복잡한 원근 장면은 여전히 수동 다듬기가 필요할 수 있음"
    ],
    "tips": [
      {
        "title": "분위기보다 가장자리",
        "text": "어두운 캔버스에서 아직 헤일로가 보이는 컷아웃을 합성하지 마세요."
      },
      {
        "title": "빛을 먼저 맞추기",
        "text": "얼굴이나 상품의 키 라이트와 일치하는 플레이트를 고르세요."
      },
      {
        "title": "마스터 분리",
        "text": "투명 PNG, 라이프스타일 내보내기, 소셜 크롭은 다른 파일이어야 합니다."
      },
      {
        "title": "글자 공간 남기기",
        "text": "포스터 배경에는 헤드라인이 앉을 조용한 구역이 필요합니다."
      },
      {
        "title": "검색 의도 분리",
        "text": "Amazon 흰 플레이트는 이커머스 글로. 이 글은 장면 변경용으로 유지하세요."
      }
    ],
    "scenarios": [
      {
        "title": "온라인에서 사진 배경 무료 교체",
        "text": "먼저 피사체를 잘라낸 뒤 새 플레이트나 생성 장면에 두세요."
      },
      {
        "title": "카페 라이프스타일 인물 배경",
        "text": "얼굴 조명에 맞는 창광 플레이트를 사용하세요."
      },
      {
        "title": "프로 사진용 오피스 배경",
        "text": "선반과 소품은 인물보다 부드럽게 유지하세요."
      },
      {
        "title": "소셜 커버용 브랜드색 배경",
        "text": "제목 공간이 있는 단색 또는 소프트 그라데이션에 투명 PNG를 올리세요."
      },
      {
        "title": "AI 컷아웃 후 배경 변경",
        "text": "머리카락·재킷 가장자리가 두 캔버스 검수를 통과할 때까지 합성하지 마세요."
      },
      {
        "title": "실물 인물 뒤 AI 생성 장면",
        "text": "Seedream 또는 FLUX.2에는 방만 만들게 하고 새 얼굴·옷은 만들지 마세요."
      },
      {
        "title": "이벤트 포스터 배경 교체",
        "text": "헤드라인이 읽히도록 깨끗한 브랜드 벽을 우선하세요."
      },
      {
        "title": "야외 주광 배경 스왑",
        "text": "태양 방향을 맞추고 부드러운 실내 얼굴에 정오 탑라이트를 피하세요."
      },
      {
        "title": "가짜처럼 보이는 배경 합성 수정",
        "text": "프린지, 빛 방향, 색온도 순으로 확인하세요."
      },
      {
        "title": "투명 PNG에서 라이프스타일 이미지로",
        "text": "마스터를 보관하고 커버 크롭은 따로 내보내세요."
      },
      {
        "title": "Amazon 흰 배경용이 아님",
        "text": "리스팅 플레이트는 이커머스 상품 가이드로 보내세요."
      },
      {
        "title": "인물 컷아웃 후 장면 변경",
        "text": "인물 워크플로에서 머리카락 검수를 마친 뒤 이 장면 워크플로를 여세요."
      }
    ],
    "toolFaq": [
      {
        "q": "온라인에서 사진 배경을 무료로 바꾸려면?",
        "a": "로그인 후 원본 배경을 투명 PNG로 제거하고 새 장면이나 단색에 피사체를 두세요."
      },
      {
        "q": "투명 PNG로 라이프스타일 이미지를 만들려면?",
        "a": "빛이 맞는 플레이트에 합성하고 접촉·색온도를 확인한 뒤 마스터를 커버 크롭과 분리하세요."
      },
      {
        "q": "셀피 배경을 카페 장면으로 바꿀 수 있나요?",
        "a": "네. 먼저 인물을 잘라낸 뒤 비슷한 창광의 카페 플레이트에 합성하세요."
      },
      {
        "q": "실물 인물 뒤에 새 AI 장면을 생성할 수 있나요?",
        "a": "네. 실물 피사체를 남기고 Seedream 또는 FLUX.2에는 환경만 만들게 하세요."
      },
      {
        "q": "이벤트 포스터 배경 교체에 쓸 도구는?",
        "a": "컷아웃은 Background Remover, 조용한 브랜드 벽에 배치하고 필요하면 헤드라인 글자를 더하세요."
      },
      {
        "q": "소셜 커버 배경 교체에 쓸 도구는?",
        "a": "Background Remover와 브랜드색·그라데이션 벽. 더 풍부한 장면은 Seedream 또는 FLUX.2로."
      },
      {
        "q": "가짜처럼 보이는 배경 합성을 고치려면?",
        "a": "내보내기 전 프린지를 정리하고 빛 방향을 맞추며 색온도를 통일하세요."
      },
      {
        "q": "배경 변경 시 야외 주광 불일치를 고치려면?",
        "a": "태양 방향을 맞추고 실내용 얼굴에 정오 탑라이트를 피하세요."
      },
      {
        "q": "동영상 커버에 배경 변경을 쓸 수 있나요?",
        "a": "네. 커버 비율 크롭을 내보내고 세이프 에어리어 안에 피사체를 두세요."
      },
      {
        "q": "Amazon 흰 상품 배경에 쓸 수 있나요?",
        "a": "아니요. 마켓플레이스 흰 플레이트에는 이커머스 상품 배경 가이드를 사용하세요."
      }
    ]
  },
  "articles": {
    "ai-portrait-background-remover": {
      "title": "무료 AI 인물 배경 제거: 헤드샷, 아바타, 증명사진",
      "excerpt": "어수선한 셀피를 깔끔한 헤드샷으로. 인물 배경을 무료로 제거하고 투명 PNG를 내보낸 뒤 LinkedIn·이력서·아바타용 흰·파랑·브랜드색을 더하세요.",
      "metaTitle": "무료 AI 인물 배경 제거 | Miral",
      "metaDescription": "Miral AI로 인물 배경을 무료 제거하세요. 머리카락 디테일을 유지하고 투명 PNG를 내보내 LinkedIn 헤드샷이나 흰·파란 증명사진 스타일을 만드세요.",
      "target": {
        "label": "인물 배경 제거 열기",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "무료 인물 배경 제거",
        "AI 헤드샷 배경 제거",
        "LinkedIn 사진 배경 제거",
        "증명사진 배경 제거",
        "아바타 배경 제거",
        "머리카락 주변 배경 제거",
        "이력서 사진 흰 배경",
        "파란 배경 증명사진 온라인"
      ]
    },
    "ai-background-changer-online": {
      "title": "무료 AI 배경 체인저: 라이프스타일, 소셜 커버, 이벤트 포스터",
      "excerpt": "옛 배경을 무료로 제거한 뒤 카페 라이프스타일, 브랜드 그라데이션 소셜 커버, 이벤트 포스터 벽에 인물을 배치—이커머스 흰 배경 의도와 분리합니다.",
      "metaTitle": "무료 AI 배경 체인저 온라인 | Miral",
      "metaDescription": "Miral AI로 사진 배경을 온라인에서 바꾸세요. 투명 PNG로 잘라낸 뒤 카페 라이프스타일, 소셜 커버, 이벤트 포스터 장면을 만드세요.",
      "target": {
        "label": "AI 배경 제거 열기",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "무료 AI 배경 체인저",
        "사진 배경 온라인 교체",
        "컷아웃 후 배경 변경",
        "AI 장면 교체",
        "라이프스타일 배경 체인저",
        "인물용 카페 배경",
        "소셜 커버 배경 교체",
        "투명 PNG 새 배경"
      ]
    }
  }
}
